<template>
  <div class="container">
    <h1>Home page</h1>
  </div>
</template>
<script>

export default {
  name: "HomePage"
}
</script>

<style scoped>

</style>